export default function Home() {
  return (
    <main className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="bg-primary/10 flex h-16 w-16 items-center justify-center rounded-2xl">
          <span className="text-primary text-2xl font-bold">J</span>
        </div>
        <h1 className="text-foreground text-2xl font-semibold tracking-tight">
          Type4Work
        </h1>
        <p className="text-muted-foreground max-w-xs text-sm">
          Navigate to a form or chat link to get started.
        </p>
      </div>
    </main>
  );
}
